import { Avatar } from 'antd';

export function Image({
  avatar_src,
  isImageRender,
}: {
  avatar_src: string;
  isImageRender: boolean;
}) {
  return (
    <>
      {isImageRender ? (
        <Avatar src={avatar_src} size={40} />
      ) : (
        <Avatar
          src={'https://cdn0.iconfinder.com/data/icons/user-pictures/100/matureman1-512.png'}
          size={40}
        />
      )}
    </>
  );
}
